<template>
  <div style="background: rgb(243,243,243)">
    <CellGroup title="告警信息">
      <Cell
        value-class="cell-value"
        title="告警名称"
        :value="alarm.eventName"
      />
      <Cell value-class="cell-value" title="发生时间" :value="alarm.time" />
      <Cell value-class="cell-value" title="附加数据" :value="getParams" />
    </CellGroup>
    <CellGroup title="处理信息" v-if="alarm.handleMethod">
      <Cell
        value-class="cell-value"
        title="处理人"
        :value="alarm.handleUserRealName"
      />
      <Cell
        value-class="cell-value"
        title="处理时间"
        :value="alarm.handleTime"
      />
      <Cell
        value-class="cell-value"
        title="处理方式"
        :value="
          $DICT.getValue('DEVICE_ALARM_HANDLE_METHOD', alarm.handleMethod)
        "
      />
      <Cell
        value-class="cell-value"
        title="处理意见"
        :value="alarm.handleRemark"
      />
      <Cell
        :style="{ display: alarm.autoRecoverTime == null ? 'none' : '' }"
        value-class="cell-value"
        title="恢复时间"
        :value="alarm.autoRecoverTime"
      />
      <Cell value-class="cell-value" title="处理照片" />
      <div
        style="display:flex;justify-content : space-between;width:75%; margin:auto;margin-top:8px;"
      >
        <UploadImage
          style="margin-left:-15px"
          :imageList="alarm.handleImageList"
        />
      </div>
    </CellGroup>
    <div style="height: 45px;background: #fff"></div>
    <pf v-if="!alarm.handleMethod" code="DEVICE_HANDLE_ALARM">
      <Button
        type="danger"
        block
        class="fixed-bottom-button"
        @click="handleAlarm"
        >警情处理</Button
      >
    </pf>
  </div>
</template>

<script>
import { Button, Cell, CellGroup } from "vant";
import UploadImage from "@/components/UploadImage";

export default {
  components: { CellGroup, Cell, UploadImage, Button },
  props: {},
  data() {
    return {
      alarmId: this.$route.params.id,
        deviceId: this.$route.params.deviceId,
      alarm: {},
    };
  },
  computed: {
    getParams() {
      const { params } = this.alarm;
      let result = "";
      if (params) {
        JSON.parse(params).map((item) => {
          result += item.name + " （" + item.value + "）\r\n";
        });
      }
      return result;
    },
  },
  created() {},
  mounted() {
    this.getAlarmDetail();
  },
  methods: {
    getAlarmDetail() {
      if (this.alarmId == undefined ||this.alarmId=='undefined') {
        this.$toast.fail(`告警id为空`);
      } else {
        this.$http.tokiot.enterprise.alarm.get({ id: this.alarmId ,deviceId:this.deviceId}).then((res) => {
          if (res) {
            this.alarm = res;
          }
        });
      }
    },
    handleAlarm() {
      return this.$router.push("/alarm/alarmDeal/" + this.alarm.deviceId);
    },
  },
  watch: {},
};
</script>

<style scoped></style>
